import Layout from "../../Layout";
import Articles from "./Articles";

const HomePage = () => {
  return (
    <Layout>
      <Articles />
    </Layout>
  );
};

export default HomePage;
